﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SessionActionTypes;
(function (SessionActionTypes) {
    SessionActionTypes["SET_SESSION"] = "SET_SESSION";
    SessionActionTypes["AFTER_LOGOUT"] = "AFTER_LOGOUT";
})(SessionActionTypes = exports.SessionActionTypes || (exports.SessionActionTypes = {}));
exports.actionCreators = {
    setSession: (payload) => ({
        type: SessionActionTypes.SET_SESSION,
        payload: payload
    }),
    afterLogout: () => ({
        type: SessionActionTypes.AFTER_LOGOUT
    })
};
//# sourceMappingURL=actions.js.map